import instoreAllOffersMapModalSaga from './InstoreAllOffersMapModal';

export default instoreAllOffersMapModalSaga;
